module.exports = "/packs/014-210100817d87501b45b3bf585f98021b.jpg";